import { Images } from "../../../Images";
import BigNum from "../../math/BigNum";
import Values from "../../value/Values";
import MinedDamageBonusSkillNode from "./MinedDamageBonusSkillNode";
import { SkillIds } from "../SkillIds";
import SkillType from "../SkillType";

export default class MinedDamageBonusSkill extends SkillType {
    /**
     * @param {Totals} totals
     * @param {Values} values
     */
    constructor(totals, values) {
        super(SkillIds.UPGRADE_BONUS_MULTIPLICATIVE);

        /**
         * @constant
         * @type {Values}
         */
        this.values = values;

        const inc = 5;
        let cost = 5;
        let purchaseIndex = 0;

        const bonus1 = this.addNode(new MinedDamageBonusSkillNode('upgradeBonusMult1', 
            totals, Images.currency.upgrades, new BigNum(cost), this, this.values, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const bonus2 = this.addNode(new MinedDamageBonusSkillNode('upgradeBonusMult2', 
            totals, Images.currency.upgrades, new BigNum(cost), this, this.values, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const bonus3 = this.addNode(new MinedDamageBonusSkillNode('upgradeBonusMult3', 
            totals, Images.currency.upgrades, new BigNum(cost), this, this.values, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const bonus4 = this.addNode(new MinedDamageBonusSkillNode('upgradeBonusMult4', 
            totals, Images.currency.upgrades, new BigNum(cost), this, this.values, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const bonus5 = this.addNode(new MinedDamageBonusSkillNode('upgradeBonusMult5', 
            totals, Images.currency.upgrades, new BigNum(cost), this, this.values, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const bonus6 = this.addNode(new MinedDamageBonusSkillNode('upgradeBonusMult6', 
            totals, Images.currency.upgrades, new BigNum(cost), this, this.values, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const bonus7 = this.addNode(new MinedDamageBonusSkillNode('upgradeBonusMult7', 
            totals, Images.currency.upgrades, new BigNum(cost), this, this.values, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const bonus8 = this.addNode(new MinedDamageBonusSkillNode('upgradeBonusMult8', 
            totals, Images.currency.upgrades, new BigNum(cost), this, this.values, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const bonus9 = this.addNode(new MinedDamageBonusSkillNode('upgradeBonusMult9', 
            totals, Images.currency.upgrades, new BigNum(cost), this, this.values, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const bonus10 = this.addNode(new MinedDamageBonusSkillNode('upgradeBonusMult10', 
            totals, Images.currency.upgrades, new BigNum(cost), this, this.values, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const bonus11 = this.addNode(new MinedDamageBonusSkillNode('upgradeBonusMult11', 
            totals, Images.currency.upgrades, new BigNum(cost), this, this.values, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const bonus12 = this.addNode(new MinedDamageBonusSkillNode('upgradeBonusMult12', 
            totals, Images.currency.upgrades, new BigNum(cost), this, this.values, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const bonus13 = this.addNode(new MinedDamageBonusSkillNode('upgradeBonusMult13', 
            totals, Images.currency.upgrades, new BigNum(cost), this, this.values, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const bonus14 = this.addNode(new MinedDamageBonusSkillNode('upgradeBonusMult14', 
            totals, Images.currency.upgrades, new BigNum(cost), this, this.values, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const bonus15 = this.addNode(new MinedDamageBonusSkillNode('upgradeBonusMult15', 
            totals, Images.currency.upgrades, new BigNum(cost), this, this.values, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const bonus16 = this.addNode(new MinedDamageBonusSkillNode('upgradeBonusMult16', 
            totals, Images.currency.upgrades, new BigNum(cost), this, this.values, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const bonus17 = this.addNode(new MinedDamageBonusSkillNode('upgradeBonusMult17', 
            totals, Images.currency.upgrades, new BigNum(cost), this, this.values, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const bonus18 = this.addNode(new MinedDamageBonusSkillNode('upgradeBonusMult18', 
            totals, Images.currency.upgrades, new BigNum(cost), this, this.values, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const bonus19 = this.addNode(new MinedDamageBonusSkillNode('upgradeBonusMult19', 
            totals, Images.currency.upgrades, new BigNum(cost), this, this.values, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const bonus20 = this.addNode(new MinedDamageBonusSkillNode('upgradeBonusMult20', 
            totals, Images.currency.upgrades, new BigNum(cost), this, this.values, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const bonus21 = this.addNode(new MinedDamageBonusSkillNode('upgradeBonusMult21', 
            totals, Images.currency.upgrades, new BigNum(cost), this, this.values, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const bonus22 = this.addNode(new MinedDamageBonusSkillNode('upgradeBonusMult22', 
            totals, Images.currency.upgrades, new BigNum(cost), this, this.values, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const bonus23 = this.addNode(new MinedDamageBonusSkillNode('upgradeBonusMult23', 
            totals, Images.currency.upgrades, new BigNum(cost), this, this.values, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const bonus24 = this.addNode(new MinedDamageBonusSkillNode('upgradeBonusMult24', 
            totals, Images.currency.upgrades, new BigNum(cost), this, this.values, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const bonus25 = this.addNode(new MinedDamageBonusSkillNode('upgradeBonusMult25', 
            totals, Images.currency.upgrades, new BigNum(cost), this, this.values, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const bonus26 = this.addNode(new MinedDamageBonusSkillNode('upgradeBonusMult26', 
            totals, Images.currency.upgrades, new BigNum(cost), this, this.values, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const bonus27 = this.addNode(new MinedDamageBonusSkillNode('upgradeBonusMult27', 
            totals, Images.currency.upgrades, new BigNum(cost), this, this.values, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const bonus28 = this.addNode(new MinedDamageBonusSkillNode('upgradeBonusMult28', 
            totals, Images.currency.upgrades, new BigNum(cost), this, this.values, purchaseIndex
        ));



        bonus1.addChildNode(bonus2);
        bonus2.addChildNode(bonus3);
        bonus3.addChildNode(bonus4);
        bonus4.addChildNode(bonus5);
        bonus5.addChildNode(bonus6);
        bonus6.addChildNode(bonus7);
        bonus7.addChildNode(bonus8);

        bonus8.addChildNode(bonus9);
        bonus9.addChildNode(bonus10);
        bonus10.addChildNode(bonus11);
        bonus11.addChildNode(bonus12);
        bonus12.addChildNode(bonus13);
        bonus13.addChildNode(bonus14);
        bonus14.addChildNode(bonus15);

        bonus15.addChildNode(bonus16);
        bonus16.addChildNode(bonus17);
        bonus17.addChildNode(bonus18);
        bonus18.addChildNode(bonus19);
        bonus19.addChildNode(bonus20);
        bonus20.addChildNode(bonus21);
        bonus21.addChildNode(bonus22);

        bonus22.addChildNode(bonus23);
        bonus23.addChildNode(bonus24);
        bonus24.addChildNode(bonus25);
        bonus25.addChildNode(bonus26);
        bonus26.addChildNode(bonus27);
        bonus27.addChildNode(bonus28);

        ///////////////////////////////////
        // Position the nodes in the graph
        ///////////////////////////////////

        // Starting coordinate of the skill
        const startX = -1;
        const startY = -7;

        bonus1.setPosition(startX, startY);
        bonus2.setPosition(startX - 1, startY);
        bonus3.setPosition(startX - 2, startY);
        bonus4.setPosition(startX - 3, startY);
        bonus5.setPosition(startX - 4, startY);
        bonus6.setPosition(startX - 5, startY);
        bonus7.setPosition(startX - 6, startY);

        bonus8.setPosition(startX - 6, startY - 1);
        bonus9.setPosition(startX - 5, startY - 1);
        bonus10.setPosition(startX - 4, startY - 1);
        bonus11.setPosition(startX - 3, startY - 1);
        bonus12.setPosition(startX - 2, startY - 1);
        bonus13.setPosition(startX - 1, startY - 1);
        bonus14.setPosition(startX, startY - 1);

        bonus15.setPosition(startX, startY - 2);
        bonus16.setPosition(startX - 1, startY - 2);
        bonus17.setPosition(startX - 2, startY - 2);
        bonus18.setPosition(startX - 3, startY - 2);
        bonus19.setPosition(startX - 4, startY - 2);
        bonus20.setPosition(startX - 5, startY - 2);
        bonus21.setPosition(startX - 6, startY - 2);

        bonus22.setPosition(startX - 6, startY - 3);
        bonus23.setPosition(startX - 5, startY - 3);
        bonus24.setPosition(startX - 4, startY - 3);
        bonus25.setPosition(startX - 3, startY - 3);
        bonus26.setPosition(startX - 2, startY - 3);
        bonus27.setPosition(startX - 1, startY - 3);
        bonus28.setPosition(startX, startY - 3);
    }
}